import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TeamMember from '../components/Contact/TeamMember';
import ContactUs from '../components/Contact/ContactUs';
import { teamMembers } from '../constants/teamMembers';

export default function Contact() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#contact') {
      const el = document.getElementById('contact');
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, [location]);

  return (
    <div className="max-w-6xl mx-auto px-4 py-16">
      <h1 className="text-4xl font-extrabold tracking-tight text-center mb-12">
        Team
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 mb-20">
        {teamMembers.map((member, index) => {
          const isLast = index === teamMembers.length - 1;
          const shouldCenter = teamMembers.length % 3 === 1 && isLast;
          return (
            <div key={index} className={shouldCenter ? 'md:col-start-2' : ''}>
              <TeamMember {...member} />
            </div>
          );
        })}
      </div>

      <h1
        id="contact"
        className="text-4xl font-extrabold tracking-tight text-center mb-12"
      >
        Contact Us
      </h1>
      <ContactUs />
    </div>
  );
}
